import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Field, FieldError, FieldLabel } from '@/components/shadcn/field';
import { Input } from '@/components/shadcn/input';

import type { CreatePartyValues } from './types';
import useRequiredByCrm from './useRequiredByCrm';

export default function BENameFields() {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext<CreatePartyValues>();

  const requiredByCrm = useRequiredByCrm();

  const firstNameLabel = t('PARTY_CREATE_INLINE_FIRST_NAME_LABEL');
  const lastNameLabel = t('PARTY_CREATE_INLINE_LAST_NAME_LABEL');

  const lastName = requiredByCrm('lastName', lastNameLabel);

  return (
    <>
      <Field data-invalid={errors.firstName ? true : undefined}>
        <FieldLabel htmlFor="firstName">
          {firstNameLabel}
          {' *'}
        </FieldLabel>

        <Input
          id="firstName"
          {...register('firstName', {
            required: t('PARTY_CREATE_INLINE_REQUIRED'),
          })}
        />

        <FieldError
          errors={errors.firstName ? [errors.firstName] : undefined}
        />
      </Field>

      <Field data-invalid={errors.lastName ? true : undefined}>
        <FieldLabel htmlFor="lastName">
          {lastNameLabel}
          {lastName.isRequired && ' *'}
        </FieldLabel>

        <Input
          id="lastName"
          {...register('lastName', { validate: lastName.validate })}
        />

        <FieldError errors={errors.lastName ? [errors.lastName] : undefined} />
      </Field>
    </>
  );
}
